import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "primereact/skeleton";
import styles from "./styles.module.css";
import { getHealthStatus } from "../../reducers/MetaData/metadata-actions";
import { useUtility } from "../../context/UtilityContext";

const StatusCard = ({ data }) => {
    const iconColors = [
        {
            status: ["green", "available"],
            color: "#4DAD01",
        },
        {
            status: ["yellow", "limited"],
            color: "#F5B379",
        },
        {
            status: ["red", "blocked"],
            color: "#E61E50",
        },
        {
            status: ["unknown"],
            color: "#B0B0B2",
        },
    ];

    const getIconColor = (status) => {
        const lowerStatus = status?.toLowerCase();

        for (let i = 0; i < iconColors.length; i++) {
            if (iconColors[i].status.includes(lowerStatus)) {
                return iconColors[i].color;
            }
        }

        return "#808080";
    };

    const getTitle = (status) => {
        switch (status?.toLowerCase()) {
            case "green":
                return "High";
            case "yellow":
                return "Medium";
            case "red":
                return "Low";
            case "tier_250":
                return "250";
            case "tier_1k":
                return "1K";
            case "tier_2k":
                return "2K";
            case "tier_10k":
                return "10K";
            case "tier_100k":
                return "100K";
            default:
                return status;
        }
    };

    return (
        <div className="mr-4">
            <h4 className="m-0 white-space-nowrap capitalize">
                {data?.icon && (
                    <i
                        className={`${data.icon} text-xs mr-2`}
                        style={{ color: getIconColor(data?.status) }}
                    />
                )}

                <span>{getTitle(data?.status)}</span>
            </h4>

            <p className="mt-1 mb-0 text-sm white-space-nowrap">
                {data.label}
            </p>
        </div>
    );
};

export default function HealthStatusInfo() {
    const dispatch = useDispatch();
    const { selectedMetadataId } = useUtility()

    const { healthStatus, healthStatusLoading } = useSelector(
        (state) => state.metadata
    );

    useEffect(() => {
        dispatch(getHealthStatus({ metadataId: selectedMetadataId }))
    }, [selectedMetadataId]);

    const details = [
        {
            icon: "",
            status:
                healthStatus?.whatsapp_business_manager_messaging_limit || "N/A",
            label: "Message Limit",
            id: "message-limit",
        },
        {
            icon: "pi pi-circle-fill",
            status: healthStatus?.quality_rating || "UNKNOWN",
            label: "Phone Quality",
            id: "phone-quality",
        },
    ];

    return (
        <div className={`p-3 w-full ${styles["proinfo-box"]} overflow-y-auto`}>
            {healthStatusLoading ? (
                <Skeleton width="100%" height="3rem" />
            ) : (
                <div className="flex gap-4 align-items-end">
                    {details.map((item) => (
                        <StatusCard key={item.id} data={item} />
                    ))}
                </div>
            )}
        </div>
    );
}